function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M17.146,10.437l1.232-3.646,3.071,3.646Zm-.467,1.381H21.4l-7.65,8.662,2.927-8.662Zm-9.358,0,2.927,8.661L2.6,11.818Zm-.467-1.381h-4.3L5.622,6.791l1.232,3.646Zm1.19-.791L6.846,6.1h3.793l-2.6,3.547ZM13.361,6.1h3.793l-1.2,3.547L13.361,6.1ZM9.177,10.437,12,6.578l2.823,3.859Zm6.045,1.381L12,21.35,8.778,11.818Zm-9.159-7.1A1.074,1.074,0,0,0,5.24,5.1L.753,10.428a1.077,1.077,0,0,0,.016,1.4l10.425,11.8a1.075,1.075,0,0,0,1.612,0l10.425-11.8a1.077,1.077,0,0,0,.016-1.4L18.76,5.1a1.073,1.073,0,0,0-.822-.383Zm6.6-1.443V.665a.665.665,0,1,0-1.33,0v2.61a.665.665,0,0,0,1.33,0ZM4.635,4.366a.664.664,0,0,0,0-.94L2.693,1.483a.665.665,0,1,0-.94.94L3.695,4.365a.663.663,0,0,0,.94,0Zm15.693,0L22.193,2.5a.665.665,0,0,0-.94-.941L19.387,3.423a.665.665,0,1,0,.941.941Z",
  transform: "translate(-0.5)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/jewellery.4276fa92.svg";
export { SvgComponent as ReactComponent };